<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form ref="form">
        <v-row>
          <h2 class="pb-5">{{ this.pageTitle }}</h2>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5">
              <v-text-field
                outlined
                label="Corporate ID"
                type="text"
                v-model="formData.corpid"
                maxlength="30"
                :rules="[rules.required]"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" class="pb-n5 mt-n8">
              <v-autocomplete
                outlined
                :label="this.$t('allbank.companybankacc')"
                v-model="formData.bankaccountid"
                :items="bankList"
                :rules="[rules.required]"
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>

        <v-row>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="backHandler">
              {{$t('button.back')}}
            </v-btn>
          </div>
          <div class="pt-5 pl-4 pb-4">
            <v-btn color="warning" style="width: 100px" @click="getMaybankExportListHandler">
              {{$t('button.export')}}
            </v-btn>
          </div>
        </v-row>
      </v-form>
    </v-container>
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  props: {
    parentObject: Object,
  },

  components: {
    "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
      },
      pageTitle: this.$t('alleis.maybankeisexportformat'),

      id: this.parentObject.id,
      data: this.parentObject.data,
      formData: {
        employername: '',
        debitacc: '',
        bankaccountid: null,
        corpid: '',
      },

      titleData: null,
      eisdata: [],
      bankaccounts: [],
      bankList: [],

      totalContAmt: null,

      accErr: [],

      loading: false,

      processedCount: null,
      successCount: null,
      errCount: null,

      errMsg: "",
      isErr: false,
      isEdit: this.parentObject.isEdit,
    };
  },

  methods: {
    getMaybankExportListHandler() {
      if (!this.$refs.form.validate()) {
        this.isErr = true;
        this.errMsg = this.$t('vdatatable.someinfoismissing');
        return;
      }

      this.loading = true;
      const vm = this;

      let dateHolder2 = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-" + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder2).format("YYYY-MM-DD");

      this.$store.dispatch('get', {
        url: `/maybankeisexport/all/${this.$store.getters.userId}`
          + "/" + this.data.eisexprecid
          + "/" + this.data.refnum + "/" + date + "/" + date
      })
        .then(function (res) {
          vm.loading = false;
          vm.eisdata = res.data.rec;

          if (!vm.eisdata || vm.eisdata.length === 0) {
            vm.isErr = true;
            vm.errMsg = 'No staff data found for this submission record / reference number.';
            return;
          }

          const bankacc = vm.bankaccounts.find(b => b.id === vm.formData.bankaccountid);
          vm.formData.employername = vm.eisdata[0].compnyname || '';
          vm.formData.debitacc = bankacc ? bankacc.accountno : '';

          vm.exportHandler();
        })
        .catch(function (err) {
          vm.loading = false;
          vm.errMsg = err;
        });
    },

    buildHeader() {
      const batchid = "M" + moment().format("DDHHmmss");
      const refnum = String(this.data.refnum || "").replace(/[^0-9A-Za-z]/g, "").substring(0, 12);
      const monthYear = this.padRJ(this.data.month, 2) + this.data.year;
      const valuedate = moment().format("DDMMYYYY");

      const fields = new Array(42).fill("");
      fields[0] = "00";
      fields[1] = "Statutory Body";
      fields[2] = "9";
      fields[3] = "02";
      fields[4] = refnum;
      fields[5] = this.formData.employername;
      fields[6] = monthYear;
      fields[7] = this.formData.debitacc;
      fields[8] = valuedate;
      fields[20] = batchid;
      fields[21] = this.formData.corpid;
      return fields.join("|");
    },

    buildRecord(element) {
      const fields = new Array(136).fill("");
      const stfamount = element.stfeis || 0;
      const coamount = element.coeis || 0;

      let refnoholder = element.refno ? String(element.refno).replace(/[-\s]/g, "") : "";

      // New ID No (field 9) — the employee's IC number, if they have one on file.
      let newicno = "";
      if (element.personidnotype == 1 && element.personidno) {
        newicno = String(element.personidno).replace(/[-\s]/g, "");
      }

      fields[0] = "01";
      fields[1] = element.staffcode || "";
      fields[4] = element.psnname || "";
      fields[7] = refnoholder;
      fields[8] = newicno;
      fields[11] = stfamount.toFixed(2);
      fields[12] = coamount.toFixed(2);
      return { text: fields.join("|"), stfamount, coamount };
    },

    buildFooter(records) {
      let totalEmployee = 0;
      let totalEmployer = 0;
      let recEmployee = 0;
      let recEmployer = 0;

      records.forEach((r) => {
        totalEmployee += r.stfamount;
        totalEmployer += r.coamount;
        if (r.stfamount != 0) recEmployee++;
        if (r.coamount != 0) recEmployer++;
      });

      this.totalContAmt = (totalEmployee + totalEmployer).toFixed(2);

      const fields = new Array(28).fill("");
      fields[0] = "99";
      fields[1] = totalEmployee.toFixed(2);
      fields[2] = totalEmployer.toFixed(2);
      fields[3] = String(recEmployee);
      fields[4] = String(recEmployer);
      fields[5] = String(records.length);
      fields[6] = (totalEmployee + totalEmployer).toFixed(2);
      return fields.join("|");
    },

    async getData() {
      const vm = this;
      let neweisdetail = [];
      let dataholder = vm.eisdata;
      let eisdetail = this.filter(dataholder);

      this.processedCount = dataholder.length;
      this.successCount = eisdetail.length;
      this.errCount = dataholder.length - eisdetail.length;

      eisdetail.forEach(function (o) {
        var existing = neweisdetail.filter(function (i) {
          return i.staffcode === o.staffcode;
        })[0];
        if (!existing) {
          neweisdetail.push(o);
        } else {
          existing.stfeis += o.stfeis;
          existing.coeis += o.coeis;
        }
      });

      const records = neweisdetail.map((element) => this.buildRecord(element));
      this.titleData = this.padRJ(vm.data.month, 2) + "_" + vm.data.year + "_MAYBANK_EIS";

      if (records.length > 0) {
        const header = this.buildHeader();
        const footer = this.buildFooter(records);
        const lines = [header, ...records.map((r) => r.text), footer];
        this.download(lines.join("\n"), this.titleData);
      }
    },

    filter(item) {
      let checkdet = this.detailfilter(item);
      let checkactive = this.activefilter(checkdet);
      let checkpayment = this.paymentfilter(checkactive);
      return checkpayment;
    },

    detailfilter(item) {
      let dateHolder = this.data.year + "-" + this.padRJ(this.data.month, 2) + "-"
        + this.daysInMonth(this.data.month, this.data.year);
      let date = moment(dateHolder).format("YYYY-MM-DD");
      let dataitem = item.filter((e) => e.refnum == this.data.refnum);
      dataitem = dataitem.filter((e) => {
        return moment(e.startdate).format("YYYY-MM-DD") <= date && date <= moment(e.enddate).format("YYYY-MM-DD");
      });
      let noacc = item.filter((e) => !dataitem.includes(e));
      for (let i = 0; i < noacc.length; i++) {
        noacc[i].errormsg = this.$t('setupreport_exportmapping.nodetailinpersonstat');
        this.accErr.push(noacc[i]);
      }
      return dataitem;
    },

    activefilter(item) {
      let data = item.filter((e) => e.pystatcode == 'ACTIVE');
      let notactive = item.filter((e) => !data.includes(e));
      for (let i = 0; i < notactive.length; i++) {
        notactive[i].errormsg = this.$t('setupreport_exportmapping.paymentisnotactive');
        this.accErr.push(notactive[i]);
      }
      return data;
    },

    paymentfilter(item) {
      let data = item.filter((e) => {
        return (e.stfeis || 0) != 0 || (e.coeis || 0) != 0;
      });
      let nopayment = item.filter((e) => !data.includes(e));
      for (let i = 0; i < nopayment.length; i++) {
        nopayment[i].errormsg = this.$t('setupreport_exportmapping.nopayment');
        this.accErr.push(nopayment[i]);
      }
      return data;
    },

    download(data, title) {
      const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", title + ".txt");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    padRJ(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },

    exportHandler() {
      this.getData();
      let item = [];
      item.totalContAmt = this.totalContAmt;
      item.accounterr = this.accErr;
      item.successCount = this.successCount;
      item.processedCount = this.processedCount;
      item.errCount = this.errCount;

      if (!this.isErr) {
        this.$router.push({ name: "monthlyeisexportlog", params: { item } });
      }
    },

    backHandler() {
      this.$router.push({ name: "monthlyeisexport" });
    },

    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },

    // Prefill with the account whose description matches the company name
    loadBankAccounts() {
      const vm = this;
      Promise.all([
        this.$store.dispatch('get', { url: '/bankaccount/all' }),
        this.$store.dispatch('get', { url: '/refnum/all' }),
      ]).then(function ([bankRes, refRes]) {
        vm.bankaccounts = bankRes.data.rec;
        vm.bankList = vm.bankaccounts.map(b => ({ text: b.accountdesc + ' - ' + b.accountno, value: b.id }));

        const ref = refRes.data.rec.find(r => r.refnum == vm.data.refnum);
        const match = ref && vm.bankaccounts.find(b => b.accountdesc === ref.compnyname);
        if (match) vm.formData.bankaccountid = match.id;
      }).catch(function (err) {
        vm.errMsg = err;
      });
    },
  },

  mounted() {
    this.loadBankAccounts();
  },
};
</script>

<style scoped>
</style>
